import { useAuthenticationContext } from '@psyomics/ui-common';
import { Header, LoadingSpinner } from '@psyomics/ui-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { UploadCsvForm } from './components/upload-csv-form/upload-csv-form';
import { useServiceForUpload } from './use-service-for-upload';

type UploadReferralsProps = {
  readonly serviceCode: string;
};

const UploadReferrals = ({ serviceCode }: UploadReferralsProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { organisation } = useAuthenticationContext();
  const { service, pending } = useServiceForUpload(serviceCode);

  if (pending) return <LoadingSpinner />;
  if (!service) return null;

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="container max-w-5xl mx-auto px-4">
        <Header className="pt-11" level="h1">
          {t('page.referralUploadJobs.uploadTitle', { serviceDescription: service.description })}
        </Header>
        <UploadCsvForm
          onUploadAcknowledged={() => navigate(`/account/${organisation}/home/bulk-referral-uploads`)}
          service={service}
        />
      </div>
    </div>
  );
};

export { UploadReferrals };
